//Development
//export const BASE_URL = "";

//UAT
export const BASE_URL = "https://ccms-uat.iffco.com"

//PROD
//export const BASE_URL = "https://ccms.iffco.com"

export const Time_OUT = 1 * 60 * 1000; // configure session time out time
// export const pattern = /^[a-zA-Z0-9\s.,_@-]*$/;// configure special char pattern
export const pattern = /^[a-zA-Z0-9\s.,_@\-:;!$#@&\-\+\)\(€¥£{}\]\[%]*$/;
